export const LEGAL_URLS = {
  termsOfUse: 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/',
  privacyPolicy: 'https://www.horizonteinteligencia.com.br/privacidade',
} as const;
